export default function PlusIcon({
  size = 'w-[26px] h-[26px]',
  color = '#2A59C6',
}) {
  return (
    <svg
      className={size}
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.11536 13H21.8846"
        stroke={color}
        strokeWidth="0.807692"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 4.11523V21.8845"
        stroke={color}
        strokeWidth="0.807692"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
